import {DataFetcher} from '@aboutyou/data-fetcher';
import {useIsFeatureActive} from '@aboutyou/feature-flags';
import React from 'react';
import {useBasketMovSection} from '../hooks/useGetBasketPageSection';
import {devMovUpsellingRecommendationSection} from './BasketMOVRecommendation/devMockData';
import {BasketMOVProps, BasketMOVView} from './BasketMOVView';

export const BasketMOV: React.FC<
  Omit<BasketMOVProps, 'refetchBasketSection'>
> = props => {
  const basketMovSectionRequest = useBasketMovSection();
  const shouldUseRecommendationMocks = useIsFeatureActive(
    'mov_upselling_recos',
  ).isActive;

  /**
   * Passing down the refetch function for the GetBasketPageBulk endpoint, since
   * the hardcoded stale time of zero, in combination with the disableViewWhileRefetching
   * prop, create an endless loop when trying to get any section of the GetBasketPageBulk request
   * within any component of this view. If any component in this view make a call again to
   * this EP, the request will be fetching again, and since the stale time is always zero,
   * the endpoint will be called endlessly.
   */
  const refetchBasketSection = async () => {
    await basketMovSectionRequest.refetch();
  };

  const BasketMOVViewWithOptionalRecommendationMock: React.FC<
    React.ComponentProps<typeof BasketMOVView>
  > = viewProps => {
    return (
      <BasketMOVView
        {...viewProps}
        movUpsellingRecommendationSection={
          shouldUseRecommendationMocks
            ? devMovUpsellingRecommendationSection
            : viewProps.movUpsellingRecommendationSection
        }
      />
    );
  };

  return (
    <DataFetcher
      request={basketMovSectionRequest}
      Error={() => null}
      View={BasketMOVViewWithOptionalRecommendationMock}
      viewProps={{...props, refetchBasketSection}}
      disableViewWhileRefetching
    />
  );
};
